import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  constructor() { }

  post(postParams) {

    var mapForm = document.createElement("form");
    mapForm.action = postParams["target"];
    mapForm.method = "POST";
    mapForm.target = postParams["target"];
    mapForm.rel = "noopener noreferrer";

    Object.keys(postParams).forEach(function (param) {
      var mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = param;
      mapInput.setAttribute("value", postParams[param]);
      mapForm.appendChild(mapInput);
    });

    document.body.appendChild(mapForm);
    mapForm.submit();
  }
}
